import React from 'react';
import FaqItem from './faq/FaqItem';
import styled from 'styled-components';
const StyledFAQPackage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 32px;
`;
const StyledTitle = styled.h2`
  text-align: center;
`;
const StyledFAQItemsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
`;
const StyledFAQItems = styled.div`
  flex: 0 0 calc(50% - 8px);
  box-sizing: border-box;
  border: 1px solid #dadde5;
  border-radius: 4px;
  h2 {
    margin-bottom: 0px !important;
    font-size: 16px !important;
  }
  div {
    font-size: 14px !important;
    line-height: 18px;
    padding-top: 0;
  }
  .accordion-body {
    padding-left: 16px;
    padding-right: 16px;
  }
  @media (max-width: 768px) {
    flex: 0 0 100%;
    h2 button {
      font-size: 12px !important;
    }
    div {
      font-size: 12px !important;
      line-height: 18px;
      padding-top: 0;
    }
  }
`;
const faqList = [
  {
    header: 'How long does the USPTO processing take?',
    text: 'The length of time for processing can vary. Per the USPTO, the application will begin to be reviewed in around 3 months time. The review itself takes approximately 1 month to complete. If reviewed and deemed acceptable, the USPTO will publish the mark in the Official Gazette in order to screen for any public challenges to the trademark. Once 30 days have passed and there are no challenges to the mark, it is prepared for registration which generally takes 3 months.',
  },
  {
    header: 'What and how much is the USPTO Filing fee?',
    text: 'Trademark Genius will collect and pay the government Base application (Sections 1 and 44), per class filing fee of $350. Our pricing includes a base cost of $450 per class, which covers the application filing fee and ensures that we can process your application thoroughly, even in cases where additional information is required.',
  },
  {
    header: 'Where can I check the status of my application with the USPTO?',
    text: (
      <>
        The status of your application can be viewed by visiting the USPTO’s
        Trademark Status & Document Retrieval portal, you will need your serial
        number.
        <br />
        <br />
        Trademark Status & Document Retrieval:{' '}
        <a className="linkClass" href="https://tsdr.uspto.gov/">
          https://tsdr.uspto.gov/
        </a>
        <br />
        <br />
        If you have questions regarding your status, inquiry is available in a
        variety of methods on the USPTO contact information page:
        <br />
        <br />
        USPTO Contact Information Page:{' '}
        <a
          className="linkClass"
          href="https://www.uspto.gov/trademarks/contact-trademarks"
        >
          https://www.uspto.gov/trademarks/contact-trademarks
        </a>
      </>
    ),
  },
  {
    header: 'Can I make changes to the mark after it has been filed?',
    text: 'Yes. There are fees involved with changes, they are dependent on how far along the trademark is in the process. If a change is needed after the mark has been published to the Official Gazette, a Post-Publication Amendment will need to be filed. Drastic changes to the trademark itself may require filing a new application instead, along with separate filings fees.',
  },
];

const FAQPackage = () => {
  return (
    <StyledFAQPackage>
      <StyledTitle>FAQs</StyledTitle>
      <StyledFAQItemsContainer>
        {faqList &&
          faqList.map((faqItem, i) => (
            <StyledFAQItems>
              <FaqItem
                key={i}
                faqId={i}
                header={faqItem.header}
                text={faqItem.text}
              />
            </StyledFAQItems>
          ))}
      </StyledFAQItemsContainer>
    </StyledFAQPackage>
  );
};

export default FAQPackage;
